var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rain on tent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M46.779 53H9.22L28 23.267 46.779 53zM26.226 20.458L5.232 53.7A1.5 1.5 0 0 0 6.5 56h43a1.5 1.5 0 0 0 1.268-2.301l-20.994-33.24 1.994-3.158a1.5 1.5 0 0 0-2.536-1.602L28 17.649l-1.232-1.95a1.5 1.5 0 0 0-2.536 1.602l1.994 3.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M21.226 53h13.548L28 42.303 21.226 53zm8.041-14.303l9.5 15A1.5 1.5 0 0 1 37.5 56h-19a1.5 1.5 0 0 1-1.267-2.303l9.5-15a1.5 1.5 0 0 1 2.534 0zm21.985-4.03a1.5 1.5 0 1 1 2.496 1.665l-2 3a1.5 1.5 0 1 1-2.496-1.664l2-3zm-10-14a1.5 1.5 0 1 1 2.496 1.665l-2 3a1.5 1.5 0 1 1-2.496-1.664l2-3zm9-16a1.5 1.5 0 1 1 2.496 1.665l-2 3a1.5 1.5 0 1 1-2.496-1.664l2-3zm-23-3a1.5 1.5 0 1 1 2.496 1.665l-2 3a1.5 1.5 0 1 1-2.496-1.664l2-3zm-13 13a1.5 1.5 0 1 1 2.496 1.665l-2 3a1.5 1.5 0 1 1-2.496-1.664l2-3zm-10-10a1.5 1.5 0 1 1 2.496 1.665l-2 3a1.5 1.5 0 0 1-2.496-1.664l2-3zm1 30a1.5 1.5 0 0 1 2.496 1.665l-2 3a1.5 1.5 0 0 1-2.496-1.664l2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/tent.58e0364685ac1c029f3a9eccc1966aa9.svg";
export { ForwardRef as ReactComponent };